/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface LocationAdminSerializerInner
 */
export interface LocationAdminSerializerInner {
  /**
   *
   * @type {number}
   * @memberof LocationAdminSerializerInner
   */
  readonly id: number
  /**
   *
   * @type {string}
   * @memberof LocationAdminSerializerInner
   */
  name: string
}

/**
 * Check if a given object implements the LocationAdminSerializerInner interface.
 */
export function instanceOfLocationAdminSerializerInner(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'id' in value
  isInstance = isInstance && 'name' in value

  return isInstance
}

export function LocationAdminSerializerInnerFromJSON(json: any): LocationAdminSerializerInner {
  return LocationAdminSerializerInnerFromJSONTyped(json, false)
}

export function LocationAdminSerializerInnerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LocationAdminSerializerInner {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    name: json['name'],
  }
}

export function LocationAdminSerializerInnerToJSON(
  value?: LocationAdminSerializerInner | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    name: value.name,
  }
}
